// components/brands/EmptyState.jsx
import React from 'react';
import { FiPackage } from 'react-icons/fi';

const EmptyState = ({ 
  isDarkMode, 
  title = "No brands available", 
  message = "We couldn't find any brands at the moment.",
  icon: Icon = FiPackage,
  iconSize = 32,
  actionText,
  onAction
}) => {
  return (
    <div className="flex flex-col items-center justify-center px-4 py-10">
      {/* Icon */}
      <div className="mb-3">
        <Icon 
          size={iconSize} 
          className={isDarkMode ? 'text-gray-600' : 'text-gray-300'}
        />
      </div>

      {/* Title */}
      <h3 className={`text-sm font-medium mb-1 text-center ${
        isDarkMode ? 'text-gray-300' : 'text-gray-700'
      }`}>
        {title}
      </h3>

      {/* Message */}
      <p className={`text-xs text-center max-w-xs ${
        isDarkMode ? 'text-gray-400' : 'text-gray-500'
      }`}>
        {message}
      </p>

      {/* Optional Action Button */}
      {actionText && onAction && (
        <button
          onClick={onAction}
          className={`mt-4 px-4 py-2 text-xs font-medium rounded-lg transition-colors ${
            isDarkMode 
              ? 'bg-gray-800 text-gray-300 hover:bg-gray-700' 
              : 'bg-emerald-50 text-emerald-700 hover:bg-emerald-100 border border-emerald-200'
          }`}
        >
          {actionText}
        </button>
      )}
    </div>
  );
};

export default EmptyState;